import React, { useState } from 'react';
import { toast } from 'sonner';
import { supabase } from '@/integrations/supabase/client';
import { Mail } from 'lucide-react';

const Newsletter: React.FC = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!email || !email.includes('@')) {
      toast.error('Por favor, insira um email válido');
      return;
    }

    setIsLoading(true);

    try {
      const { data, error } = await supabase
        .from('newsletter_subscribers')
        .insert([
          {
            email: email.toLowerCase().trim(),
            name: name.trim() || null,
            status: 'active',
            source: 'website',
          },
        ])
        .select();

      if (error) {
        if (error.code === '23505') {
          toast.error('Este email já está cadastrado na nossa newsletter!');
        } else {
          throw error;
        }
      } else {
        toast.success('🎉 Inscrição realizada com sucesso! Verifique seu email.');
        setEmail('');
        setName('');
      }
    } catch (error) {
      console.error('Erro ao cadastrar email:', error);
      toast.error('Erro ao cadastrar. Tente novamente mais tarde.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="py-16 bg-gradient-to-r from-blue-600 to-blue-800">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center text-white">
          <div className="mb-6">
            <Mail className="w-16 h-16 mx-auto text-white" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Receba Ofertas Exclusivas!
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Cadastre seu email e receba promoções, dicas de aquarismo e lançamentos em primeira mão
          </p>

          <form onSubmit={handleSubmit} className="space-y-4 max-w-xl mx-auto mb-6">
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="text"
                placeholder="Seu nome (opcional)"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="flex-1 px-6 py-4 rounded-full text-gray-900 text-lg focus:outline-none focus:ring-4 focus:ring-orange-300"
                disabled={isLoading}
              />
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                placeholder="Digite seu melhor email..."
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="flex-1 px-6 py-4 rounded-full text-gray-900 text-lg focus:outline-none focus:ring-4 focus:ring-orange-300"
                required
                disabled={isLoading}
              />
              <button
                type="submit"
                disabled={isLoading}
                className="bg-orange-500 hover:bg-orange-600 text-white font-bold px-8 py-4 rounded-full transition-colors text-lg whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isLoading ? 'Cadastrando...' : 'Cadastrar Agora'}
              </button>
            </div>
          </form>

          <p className="text-sm text-blue-200">
            🔒 Seus dados estão seguros. Não compartilhamos com terceiros.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
